import { DatePipe } from '@angular/common';
import { HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { IonicModule } from '@ionic/angular/lazy';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { routes } from '@/app/app/app.routes';
import { authInterceptor } from '@/shared/lib/core/interceptors/auth.interceptor';
import { errorInterceptor } from '@/shared/lib/core/interceptors/error.interceptor';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor]), withFetch()),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
      IonicModule.forRoot({
        rippleEffect: false,
        // Pass modal componentProps through setInput() so signal inputs (input()) receive them
        useSetInputAPI: true,
        // mode: 'ios'
      })
    ),
    DatePipe,
  ],
};
